import { Box } from "@material-ui/core";

export const IconBasedContentBox = ({
    children,
    icon
}) => {
    return (
        <Box display="flex" alignItems='center' gridGap={15}>
            <Box alignSelf="start">{icon}</Box>
            <Box>{children}</Box>
        </Box>
    );
}